module.exports = __webpack_public_path__ + "static/media/shuklaNVPH4.54d291e1.webp";